import { useContext } from 'react';
import { TranslationContextValue } from './translationContext.js';

function isInsideContext(context) {
  if (!context) {
    throw new Error('Wrap your Component in a TranslationProvider component');
  }
}
function useGetLanguages() {
  const context = useContext(TranslationContextValue);
  isInsideContext(context);
  return context.getAvailableLanguages;
}
function useTranslationProviderStatus() {
  const context = useContext(TranslationContextValue);
  isInsideContext(context);
  return {
    loading: context.loading,
    error: context.error
  };
}

export { useGetLanguages, useTranslationProviderStatus };
//# sourceMappingURL=hooks.js.map
